import { isNil } from "lodash";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { REDUX_PIPELINE_KEYS } from "../../../../constants/keyNames/reduxPipeline";
import { useLoanFilesHook } from "../../../../hooks/useLoanFilesHook";
import { pipelineSetKey } from "../../../../redux/reducers/pipelineReducer";
import { RouteTableScreen } from "../components/RouteTableScreen";
import { GLOBAL_EXCEPTIONS_DUMMY_DATA } from "./GlobalExceptionsTable/GLOBAL_EXCEPTIONS_DUMMY_DATA";
import GlobalExceptionsTable from "./GlobalExceptionsTable/GlobalExceptionsTable";

const ExceptionsRoute = ({ children }) => {
  // const keyName = REDUX_PIPELINE_KEYS.UPLOADED_SIZERS;
  const keyName = REDUX_PIPELINE_KEYS.EXCEPTIONS;
  const pipeline = useSelector((state) => state.pipeline?.[keyName]);
  const { getAllSizerUploads } = useLoanFilesHook();
  const dispatch = useDispatch();

  useEffect(() => {
    const rowData = GLOBAL_EXCEPTIONS_DUMMY_DATA;

    dispatch(pipelineSetKey(keyName, rowData));
    return;
    if (isNil(pipeline)) {
      getAllSizerUploads({
        onSuccessFn: (data) => {
          dispatch(pipelineSetKey(keyName, data));

          console.log("Fetched all sizer uploads:", data);
        },
        onErrorFn: (error) => {
          console.error("Error fetching sizer uploads:", error);
        },
      });
    }
  }, []);
  return (
    <RouteTableScreen rowData={pipeline}>
      <GlobalExceptionsTable />
      {/* <Txt>EXCEPTIONS - Comin Soon</Txt> */}
    </RouteTableScreen>
  );
};

export default ExceptionsRoute;
